module.exports = __webpack_public_path__ + "static/media/bill_item_discount.4c146803.svg";